<template>
  <div class="thanks" style="text-align:center;display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;">
    <div class="marquee">
      <div class="track">
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/3do.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/amiga.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/amstrad.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/appleII.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/atari2600.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/atari5200.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/atari7800.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/atarijaguar.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/atarilynx.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/atarist.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/colecovision.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/coco.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/c64.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/dragon32.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/dreamcast.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/gameboyadvance.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/gamecube.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/gamegear.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/gameboy.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/gameboycolour.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/genesis.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/intellivision.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/macintosh.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/mame.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/mastersystem.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/04/msx.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/04/neogeo.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/05/ngp_black.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/ngp.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/n64.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/nds.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/nes.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/oric.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/pc.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/pcengine.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/tg16.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/psx.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/ps2.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/psp.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/05/samcoupe.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/sega32x.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/segacd.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/sg-1000.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/snes.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/ti99.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/trs-80.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/vectrex.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/videopac.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/virtualboy.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/11/wii.png" />
        <img src="https://retropie.org.uk/wp-content/uploads/2016/03/wonderswan.png" />
      </div>
    </div>
    <h1>BLAKEJS - SCUF - CASE STUDY</h1>
    <div style="max-width: 600px;">
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;"><strong><u>Position:</u></strong> Headless Front-end Developer.</span></p>
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;"><strong><u>Experience:</u></strong> Started July 9th, 2021</span></p>
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;"><strong><u>Overview:</u></strong> In this period, I managed to help develop 5 major product landing pages for the Reflex, Instinct, Impact, Infinity4PS, and Exo. All in 4 different languages (English, French, German, and Italian) across 7 sites. This was done with the genesis project being Instinct (Code name: Troy). I learned the Prismic / Magento system very fast with the help of Aurelien, Andres, and
          Thais through an onboarding process. After I was set-up with the tools to create slices and custom type structures on dev and get them to display on dev and learn how to staging and push live, I was then able to start building our pages on the front-end from beginning to end.</span></p>
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;">I also migrate large amounts of content/html/php structures from Magento into our Headless CMS Prismic. This is a process that has been going on since the beginning. Lots of things now live on Prismic instead of in Magento. The main benefit with this is keeping content asynchronous from the site and having the ability to be &quot;Headless&quot;. A few examples of features brought over from Magento to
          Prismic would be: building out a new language switcher with new attributes of continent &amp; currency. Redesigning the footer from an old style that lived in Magento into a new style in Prismic. Implementing breadcrumbs that had settings in Prismic.</span></p>
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;">I oversaw the launches of the new products: Instinct and Reflex (technically the new Exo) that had very exciting things happen. I learned about caching, load balancing and the effects of sending thousands of people to a website can crash your servers (Reflex Drop V1 👀). I experienced what an intense holiday rush looks like. With multiple &quot;Releases&quot; happening on a schedule back-to-back from
          Black Friday to Christmas. I&apos;ve updated pages all along the way with UI/UX improvements, solved bugs and enjoyed coffees and lunches with the team.</span></p>
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;"><strong><u>Present: </u></strong>At present, there has just been a major launch of the Reflex Customization. Ongoing SEO and site improvements happening daily. Major Gaming Hub project to add to the site (along with a new content input process). Magento to Prismic migrations. XPCARE. New Reflex content. Homepage updates.&nbsp;</span></p>
      <p><span style="font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;"><strong><u>Conclusion:</u></strong> This is all to say it wouldn&apos;t have been possible without the team. I&apos;ve learned a lot in such a short time. I would say overall this has been one of the most exciting, challenging and rewarding parts of my career.</span></p>
      <p><br></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Thanks"
};
</script>

<style scoped>
.thanks {
  background-color: floralwhite;
}

h1 {
  padding-top: 10px;
}

img {
  padding: 20px 0 10px;
}

.marquee {
  position: relative;
  width: 100vw;
  max-width: 100%;
  height: 200px;
  overflow-x: hidden;
}

.track {
  position: absolute;
  white-space: nowrap;
  will-change: transform;
  animation: marquee 64s linear infinite;
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/page/Thankyouscuf.vue